import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { Link } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import { PropListItem } from "../CustomComponents/PropListItem";
import FormHelperText from '@mui/material/FormHelperText';

export default function TaskPropDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);  
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');  
    

    const [typeChoices, setTypeChoices] = React.useState([
        { label: 'Dropdown', value: '1' },
        { label: 'Text Field', value: '0' },
    ])

    const initialValues = {
        variable: '',
        format: '',
        type: '',
        IsActive: false,
        propList: []        
    };

    const validFormSchema = Yup.object({
        variable: Yup
            .string('Enter a name for this Task Variable')
            .required('Name is required'),
        format: Yup
            .string('Please enter a Regular Expresion describing the format if available.'),            
        type: Yup
            .string('Please enter the type of variable being created.')
            .required('Type is required'),
        IsActive: Yup
            .boolean(),
        propList: Yup.array().of(
            Yup.object().shape({
                Name: Yup.string().required("variable name is requried"),
                IsActive: Yup.boolean()
            })
        )
       
    })
    

        

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.variable,
            Validation: values.format,
            IsDropdown: values.type,
            IsActive: values.IsActive,
            PropList: values.propList
        };
        
		if (values.type==="1" && values.propList.length === 0) {
			setAlertText("Please add atleast one Task Property");
			setAlert(true);
			return;
		}

        handleDialogCallback(msg);
        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };

    React.useEffect(() => {
        if (refresh) {
            setRefresh(false);
        }
    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Variable
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (

                            <Form>                                
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Task Variable
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Task Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name='variable'
                                            id="outlined-taskProp"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.variable}
                                            error={props.touched.variable && Boolean(props.errors.variable)}
                                            helperText={props.touched.variable && props.errors.variable}
                                            label="Variable name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name='format'
                                            id="outlined-format"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.format}
                                            error={props.touched.format && Boolean(props.errors.format)}
                                            helperText={props.touched.format && props.errors.format}
                                            label="Format"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-propEntryType">Prop entry type</InputLabel>
                                        <CustomSelect
                                            name="type"
                                            id="outlined-propEntryType"
                                            options={typeChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.type}
                                            error={props.touched.type && Boolean(props.errors.type)}
                                            helperText={props.touched.type && props.errors.type}
                                            label="Variable entry type"
                                        />
                                          {props.touched.type && Boolean(props.errors.type) &&
													<FormHelperText error={true}>{props.errors.type}</FormHelperText>}
                                    </FormControl>
                                </div>

                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>

                                <FieldArray name="propList">
                                    {({ push, remove }) => (
                                        <div>
                                            {props.values.propList.map((p, index) => {
                                                const Name = `propList[${index}].Name`;
                                                const touchedName = getIn(props.touched, Name);
                                                const errorName = getIn(props.errors, Name);

                                                const IsActive = `propList[${index}].IsActive`;
                                                const touchedIsActive = getIn(props.touched, IsActive);
                                                const errorIsActive = getIn(props.errors, IsActive);

                                                return (
                                                    <div key={p.id}>
                                                        <FormControl sx={{ m: 1, width: 240 }}>   
                                                            <TextField                                                            
                                                                margin="normal"
                                                                variant="outlined"
                                                                label="Prop Name"
                                                                name={Name}
                                                                value={p.Name}
                                                                required
                                                                helperText={
                                                                    touchedName && errorName
                                                                        ? errorName
                                                                        : ""
                                                                }
                                                                error={Boolean(touchedName && errorName)}
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                            />
                                                        </FormControl>
                                                        <FormControlLabel
                                                            label="Active"
                                                            control={<Checkbox checked={p.IsActive} />}
                                                            name={IsActive}                                                                
                                                            onChange={props.handleChange}
                                                            helperText={
                                                                touchedIsActive && errorIsActive
                                                                    ? errorIsActive
                                                                    : ""
                                                            }
                                                            error={Boolean(touchedIsActive && errorIsActive)}                                                            
                                                        />                                                        
                                                        <Button                                                            
                                                            margin="normal"
                                                            type="button"
                                                            color="secondary"
                                                            variant="outlined"
                                                            onClick={() => remove(index)}
                                                        >
                                                            x
                                                        </Button>
                                                    </div>
                                                );
                                            })}
                                            <Button                                                
                                                type="button"
                                                variant="outlined"
                                                onClick={() =>
                                                    push({ id: props.values.propList.length, Name:"", IsActive: false})
                                                }
												disabled={props.values.type === "0"}
                                            >
                                                Add
                                            </Button>
                                        </div>
                                    )}
                                </FieldArray>                            
                            </Form>
                        )}
                    </Formik>                    
                </DialogContent>                
            </Dialog>
            <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>
        </div>
    );
}